import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";

@DwCustomContextDefinition({
    keyName: 'checkride-result-context',
    display: 'Checkride Result Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.CheckRideRequest,
})
@Injectable()
export class CheckrideResultContextService extends DwCustomContextBase {

     constructor(
            @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        ) {
            super();
        }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext, contextData) => {
            const checkrideRequest: CheckRideRequestEntity = resolvedContext.data;

            return checkrideRequest?.CheckRideResult;
        };

        contextDef.item = AppMetaDataItemNames.CheckRideResult;
        contextDef.useItemMetaData = true;
    }
} 